import React from 'react'

export default function useCombinedRefs(...refs: React.Ref<any>[]): React.Ref<any> {
  const targetRef = React.useRef()

  React.useEffect(() => {
    refs.forEach(ref => {
      if (!ref) return

      if (typeof ref === 'function') {
        ref(targetRef.current)
      } else {
        (ref.current as any) = targetRef.current
      }
    })
  }, [refs])

  return targetRef
}